import { Component, Input } from '@angular/core';
import { Card } from "../../../../shared/components/card/card";
import { ICardInfoData } from '../../../../shared/interfaces/card-info.interface';

@Component({
  selector: 'app-card-container',
  imports: [Card],
  templateUrl: './card-container.html',
  styleUrl: './card-container.scss'
})
export class CardContainer {

  @Input() cards: ICardInfoData[] = [];

}
